import { Injectable } from '@angular/core';

@Injectable()
export class PopupService {
  public showing: boolean;
  public french: boolean;

  constructor() {
    this.showing = false;
    this.french = false;
  }

  hide() { this.showing = false; }

  show() { this.showing = true; }

  inFrench(french: boolean) {
    this.french = french;
  }
}
